import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store-config';
import { ModalState } from './modal.slice';
import { ModalTypes } from '../../../views/common/enums/modal-types.enum';

const selectModalSlice = (state: RootState): ModalState => state.modalState;

export const selectModalState = (modalType: ModalTypes) =>
  createSelector([selectModalSlice], (modal) => modal[modalType]);
